import React from "react";

const ArrowRight = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path d="M1 7h12m-4-4 4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Contact() {
  return (
    <div>
      {/* Header */}
      <section style={{ padding: "80px 64px 64px" }} className="pte-contact-header">
        <div className="eyebrow" style={{ marginBottom: 16 }}>Get in touch</div>
        <h1 style={{ fontSize: 72, lineHeight: 1, marginBottom: 24 }}>Contact Us</h1>
        <p style={{ fontSize: 18, color: "var(--ink-soft)", maxWidth: 540, lineHeight: 1.6 }}>
          Send us a message, give us a call, or stop by our Greenbelt office.
          We respond to quote requests the same business day.
        </p>
      </section>

      {/* Main content */}
      <section style={{ padding: "0 64px 100px" }} className="pte-contact-body">
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 64,
          alignItems: "start",
        }} className="pte-contact-grid">

          {/* Left: contact details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 48 }}>
            <ContactBlock title="Email us">
              <a
                href="mailto:settle@preferredtitle.us"
                className="btn btn-dark"
                style={{ alignSelf: "flex-start", marginTop: 12 }}
              >
                settle@preferredtitle.us <ArrowRight />
              </a>
              <p style={{ fontSize: 14, color: "var(--ink-soft)", marginTop: 12, lineHeight: 1.5 }}>
                Send us the details of your transaction and we'll respond with a free quote the same business day.
              </p>
            </ContactBlock>

            <ContactBlock title="Call us">
              <a
                href="tel:3015139090"
                style={{ fontSize: 32, fontFamily: "var(--serif)", color: "var(--maroon)", textDecoration: "none", display: "block", marginTop: 12 }}
              >
                (301) 513-9090
              </a>
              <p style={{ fontSize: 14, color: "var(--ink-soft)", marginTop: 8, lineHeight: 1.5 }}>
                Monday – Friday, 9am – 5pm
              </p>
            </ContactBlock>

            <ContactBlock title="Visit us">
              <address style={{ fontStyle: "normal", fontSize: 16, color: "var(--ink)", lineHeight: 1.7, marginTop: 12 }}>
                7701 Greenbelt Rd, Suite 513<br />
                Greenbelt, MD 20770
              </address>
              <p style={{ fontSize: 14, color: "var(--ink-soft)", marginTop: 8, lineHeight: 1.5 }}>
                Free parking available.
              </p>
            </ContactBlock>
          </div>

          {/* Right: CTA card */}
          <div className="map-bg" style={{ borderRadius: 12, padding: "48px 40px", color: "var(--cream)" }}>
            <div className="eyebrow" style={{ color: "var(--gold)", marginBottom: 16 }}>Free quote · Same-day reply</div>
            <h2 style={{ color: "var(--cream)", fontSize: 40, lineHeight: 1.05, marginBottom: 16 }}>
              Get your free<br />quote today.
            </h2>
            <p style={{ fontSize: 15, opacity: 0.85, lineHeight: 1.55, marginBottom: 32, color: "var(--cream)" }}>
              Send us a few details about your transaction — purchase price, property address, and transaction type — and we'll respond with a transparent fee breakdown.
            </p>
            <a
              href="https://preferredtitle.titlecapture.com/title-quote"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ width: "100%", justifyContent: "center", padding: 16, fontSize: 15 }}
            >
              Send quote request <ArrowRight />
            </a>
            <div style={{ fontSize: 12, opacity: 0.7, textAlign: "center", marginTop: 16, fontFamily: "var(--mono)", letterSpacing: "0.05em", color: "var(--cream)" }}>
              or call (301) 513-9090
            </div>

            <div style={{ borderTop: "1px solid rgba(246,237,228,.15)", marginTop: 32, paddingTop: 24, display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                "Title insurance",
                "Settlement & deed preparation",
                "Residential and commercial — MD & DC",
                "Rush settlements available",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14, opacity: 0.85, color: "var(--cream)" }}>
                  <div style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--gold)", flexShrink: 0 }} />
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .pte-contact-header { padding: 80px 64px 64px; }
        .pte-contact-header h1 { font-size: 72px; }
        .pte-contact-body { padding: 0 64px 100px; }
        .pte-contact-grid { grid-template-columns: 1fr 1fr; }
        @media (max-width: 768px) {
          .pte-contact-header { padding: 48px 20px 40px !important; }
          .pte-contact-header h1 { font-size: 48px !important; }
          .pte-contact-body { padding: 0 20px 80px !important; }
          .pte-contact-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </div>
  );
}

function ContactBlock({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ borderTop: "1px solid var(--line)", paddingTop: 28 }}>
      <div className="eyebrow" style={{ marginBottom: 4 }}>{title}</div>
      {children}
    </div>
  );
}
